import AdsError from './AdsError.js'

export class GetFinancingDataAdsError extends AdsError {}
